import { render, staticRenderFns } from "./ModalDeletingUserData.vue?vue&type=template&id=68176b60&scoped=true&"
import script from "./ModalDeletingUserData.vue?vue&type=script&lang=js&"
export * from "./ModalDeletingUserData.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeletingUserData.vue?vue&type=style&index=0&id=68176b60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68176b60",
  null
  
)

export default component.exports